/**
 * The HIV+ information page is served as a separate static HTML entry
 * (public/[lang/]treatments/hiv-positive-hair-transplant.html) that loads no
 * analytics, ads, consent or session-recording scripts. The SPA must never
 * render it or push its URL into history, so links use a full navigation.
 */
export const HIV_PAGE_FILE = "treatments/hiv-positive-hair-transplant.html";

const LANGS = ["tr", "nl", "fr", "ar"] as const;

export const hivPagePath = (language: string): string =>
  (LANGS as readonly string[]).includes(language) ? `/${language}/${HIV_PAGE_FILE}` : `/${HIV_PAGE_FILE}`;

/**
 * Anonymous first-party counter (our own backend only — never ads/analytics).
 * Sends only the event name; no URL, referrer, cookies or identifiers.
 */
export const countHivMenuClick = (): void => {
  const url = import.meta.env.VITE_SUPABASE_URL as string | undefined;
  const key = import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY as string | undefined;
  if (!url || !key) return;
  try {
    void fetch(`${url}/rest/v1/rpc/count_sensitive_page_event`, {
      method: "POST",
      keepalive: true,
      credentials: "omit",
      referrerPolicy: "no-referrer",
      headers: { "Content-Type": "application/json", apikey: key, Authorization: `Bearer ${key}` },
      body: JSON.stringify({ p_event: "menu_click" }),
    }).catch(() => undefined);
  } catch {
    /* counting must never block navigation */
  }
};
